export function useNavigation() {
  const route = useRoute()
  const isNavigating = ref(false)

  onBeforeRouteLeave((to, from, next) => {
    isNavigating.value = true
    next()
  })

  watch(route, () => {
    isNavigating.value = false
  })

  return {
    isNavigating,
  }
}
